import {
    UPDATE_UNIT_REQUEST,
    UPDATE_UNIT_SUCCESS,
    UPDATE_UNIT_FAILURE
} from '../actions';


const initialState = {};

const UpdateUnitReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_UNIT_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case UPDATE_UNIT_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: action.payload});
        case UPDATE_UNIT_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default UpdateUnitReducer;